import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthService } from "../../auth/auth.service";
import { Router } from "@angular/router";

/**
 * This component acts as the landing page for new or returning users and allows them to log in to the
 * Online Claims system or register a new account.
 */
@Component({
	selector: 'claims-app-landing',
	templateUrl: './claims-app-landing.component.html'
})
export class ClaimsAppLandingComponent implements OnInit, OnDestroy {
	/**
	 * A subject that can be used to automatically end subscriptions when the component is destroyed.
	 * @private
	 */
	private readonly _destroying$ = new Subject<void>();
	
	// Indicates if the user is logged in.
	isLoggedIn = false;

	constructor(private authService: AuthService,
	            private router: Router) {
	}

	ngOnInit(): void {
		this.authService.loginStatusChanged
			.pipe(takeUntil(this._destroying$))
			.subscribe(() => this.loginStatusUpdated());
		this.loginStatusUpdated();
	}

	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}

	/**
	 * Performs checks when the user's login status is updated.
	 * @private
	 */
	private loginStatusUpdated() {
		// If the user is logged in, redirect to the repair facility dashboard.
		if (this.authService.isLoggedIn())
			this.router.navigate([ 'claims/repair-facility/dashboard' ]);
	}
}